import * as React from 'react';

const ArrowUpRight24: React.FC<React.SVGProps<SVGSVGElement>> = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'>
			<path
				d='M7 17L17 7M17 7V12.5M17 7H11.5'
				stroke='black'
				stroke-width='1.5'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
		</svg>
	);
};

export default ArrowUpRight24;
